const mouseImage = (id) => `/images/hardware/mice/${id}.png`;
const mouseVersion = (id, name) => ({ id, name, image: mouseImage(id) });

export const MICE_HARDWARE = [
  {
    id: "logitech-g-mice",
    name: "Logitech G Gaming Mice",
    brand: "Logitech",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "logitech-g-pro",
        name: "PRO / Esport",
        versions: [
          mouseVersion("logitech-g-pro-wireless", "Logitech G PRO Wireless"),
          mouseVersion("logitech-g-pro-x-superlight", "Logitech G PRO X SUPERLIGHT"),
          mouseVersion("logitech-g-pro-x-superlight-2", "Logitech G PRO X SUPERLIGHT 2"),
          mouseVersion("logitech-g-pro-x-superlight-2-dex", "Logitech G PRO X SUPERLIGHT 2 DEX"),
          mouseVersion("logitech-g-pro-2-lightspeed", "Logitech G PRO 2 LIGHTSPEED"),
          mouseVersion("logitech-g303-shroud", "Logitech G303 Shroud Edition"),
          mouseVersion("logitech-g303-daedalus-apex", "Logitech G303 Daedalus Apex"),
        ],
      },
      {
        id: "logitech-g502",
        name: "G502 / Polyvalente",
        versions: [
          mouseVersion("logitech-g502-hero", "Logitech G502 HERO"),
          mouseVersion("logitech-g502-lightspeed", "Logitech G502 LIGHTSPEED"),
          mouseVersion("logitech-g502-x", "Logitech G502 X"),
          mouseVersion("logitech-g502-x-lightspeed", "Logitech G502 X LIGHTSPEED"),
          mouseVersion("logitech-g502-x-plus", "Logitech G502 X PLUS"),
        ],
      },
      {
        id: "logitech-g-wireless",
        name: "LIGHTSPEED / Wireless",
        versions: [
          mouseVersion("logitech-g305-lightspeed", "Logitech G305 LIGHTSPEED"),
          mouseVersion("logitech-g309-lightspeed", "Logitech G309 LIGHTSPEED"),
          mouseVersion("logitech-g603-lightspeed", "Logitech G603 LIGHTSPEED"),
          mouseVersion("logitech-g604-lightspeed", "Logitech G604 LIGHTSPEED"),
          mouseVersion("logitech-g703-lightspeed", "Logitech G703 LIGHTSPEED"),
          mouseVersion("logitech-g903-lightspeed", "Logitech G903 LIGHTSPEED"),
          mouseVersion("logitech-g705", "Logitech G705"),
        ],
      },
      {
        id: "logitech-g-classics",
        name: "Classiques",
        versions: [
          mouseVersion("logitech-g403-hero", "Logitech G403 HERO"),
          mouseVersion("logitech-g403-prodigy", "Logitech G403 Prodigy"),
          mouseVersion("logitech-g402-hyperion-fury", "Logitech G402 Hyperion Fury"),
          mouseVersion("logitech-g203-lightsync", "Logitech G203 LIGHTSYNC"),
          mouseVersion("logitech-g102-lightsync", "Logitech G102 LIGHTSYNC"),
          mouseVersion("logitech-mx518-legendary", "Logitech MX518 Legendary"),
        ],
      },
    ],
  },
  {
    id: "razer-mice",
    name: "Razer Gaming Mice",
    brand: "Razer",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "razer-viper",
        name: "Viper / Esport",
        versions: [
          mouseVersion("razer-viper", "Razer Viper"),
          mouseVersion("razer-viper-8khz", "Razer Viper 8KHz"),
          mouseVersion("razer-viper-ultimate", "Razer Viper Ultimate"),
          mouseVersion("razer-viper-v2-pro", "Razer Viper V2 Pro"),
          mouseVersion("razer-viper-v3-hyperspeed", "Razer Viper V3 HyperSpeed"),
          mouseVersion("razer-viper-v3-pro", "Razer Viper V3 Pro"),
          mouseVersion("razer-viper-mini", "Razer Viper Mini"),
          mouseVersion("razer-viper-mini-signature-edition", "Razer Viper Mini Signature Edition"),
        ],
      },
      {
        id: "razer-deathadder",
        name: "DeathAdder",
        versions: [
          mouseVersion("razer-deathadder-elite", "Razer DeathAdder Elite"),
          mouseVersion("razer-deathadder-v2", "Razer DeathAdder V2"),
          mouseVersion("razer-deathadder-v2-pro", "Razer DeathAdder V2 Pro"),
          mouseVersion("razer-deathadder-v2-x-hyperspeed", "Razer DeathAdder V2 X HyperSpeed"),
          mouseVersion("razer-deathadder-v3", "Razer DeathAdder V3"),
          mouseVersion("razer-deathadder-v3-hyperspeed", "Razer DeathAdder V3 HyperSpeed"),
          mouseVersion("razer-deathadder-v3-pro", "Razer DeathAdder V3 Pro"),
          mouseVersion("razer-deathadder-v4-pro", "Razer DeathAdder V4 Pro"),
        ],
      },
      {
        id: "razer-basilisk",
        name: "Basilisk",
        versions: [
          mouseVersion("razer-basilisk", "Razer Basilisk"),
          mouseVersion("razer-basilisk-ultimate", "Razer Basilisk Ultimate"),
          mouseVersion("razer-basilisk-v2", "Razer Basilisk V2"),
          mouseVersion("razer-basilisk-v3", "Razer Basilisk V3"),
          mouseVersion("razer-basilisk-v3-x-hyperspeed", "Razer Basilisk V3 X HyperSpeed"),
          mouseVersion("razer-basilisk-v3-pro", "Razer Basilisk V3 Pro"),
          mouseVersion("razer-basilisk-v3-pro-35k", "Razer Basilisk V3 Pro 35K"),
        ],
      },
      {
        id: "razer-naga-cobra",
        name: "Naga / Cobra / Autres",
        versions: [
          mouseVersion("razer-naga-trinity", "Razer Naga Trinity"),
          mouseVersion("razer-naga-pro", "Razer Naga Pro"),
          mouseVersion("razer-naga-v2-hyperspeed", "Razer Naga V2 HyperSpeed"),
          mouseVersion("razer-naga-v2-pro", "Razer Naga V2 Pro"),
          mouseVersion("razer-cobra", "Razer Cobra"),
          mouseVersion("razer-cobra-pro", "Razer Cobra Pro"),
          mouseVersion("razer-orochi-v2", "Razer Orochi V2"),
          mouseVersion("razer-mamba-elite", "Razer Mamba Elite"),
          mouseVersion("razer-mamba-wireless", "Razer Mamba Wireless"),
        ],
      },
    ],
  },
  {
    id: "steelseries-mice",
    name: "SteelSeries Gaming Mice",
    brand: "SteelSeries",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "steelseries-aerox",
        name: "Aerox",
        versions: [
          mouseVersion("steelseries-aerox-3", "SteelSeries Aerox 3"),
          mouseVersion("steelseries-aerox-3-wireless", "SteelSeries Aerox 3 Wireless"),
          mouseVersion("steelseries-aerox-5-wireless", "SteelSeries Aerox 5 Wireless"),
          mouseVersion("steelseries-aerox-9-wireless", "SteelSeries Aerox 9 Wireless"),
        ],
      },
      {
        id: "steelseries-prime-rival",
        name: "Prime / Rival / Sensei",
        versions: [
          mouseVersion("steelseries-prime", "SteelSeries Prime"),
          mouseVersion("steelseries-prime-plus", "SteelSeries Prime+"),
          mouseVersion("steelseries-prime-wireless", "SteelSeries Prime Wireless"),
          mouseVersion("steelseries-rival-3", "SteelSeries Rival 3"),
          mouseVersion("steelseries-rival-3-wireless", "SteelSeries Rival 3 Wireless"),
          mouseVersion("steelseries-rival-5", "SteelSeries Rival 5"),
          mouseVersion("steelseries-rival-600", "SteelSeries Rival 600"),
          mouseVersion("steelseries-rival-650-wireless", "SteelSeries Rival 650 Wireless"),
          mouseVersion("steelseries-sensei-ten", "SteelSeries Sensei Ten"),
        ],
      },
    ],
  },
  {
    id: "corsair-mice",
    name: "Corsair Gaming Mice",
    brand: "Corsair",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "corsair-sabre-m75",
        name: "Sabre / M75",
        versions: [
          mouseVersion("corsair-m75-air-wireless", "Corsair M75 Air Wireless"),
          mouseVersion("corsair-m75-wireless", "Corsair M75 Wireless"),
          mouseVersion("corsair-m75", "Corsair M75"),
          mouseVersion("corsair-sabre-rgb-pro", "Corsair Sabre RGB Pro"),
          mouseVersion("corsair-sabre-rgb-pro-wireless", "Corsair Sabre RGB Pro Wireless"),
        ],
      },
      {
        id: "corsair-polyvalent",
        name: "Polyvalente",
        versions: [
          mouseVersion("corsair-dark-core-rgb-pro", "Corsair Dark Core RGB Pro"),
          mouseVersion("corsair-dark-core-rgb-pro-se", "Corsair Dark Core RGB Pro SE"),
          mouseVersion("corsair-darkstar-wireless", "Corsair Darkstar Wireless"),
          mouseVersion("corsair-nightsabre-wireless", "Corsair Nightsabre Wireless"),
          mouseVersion("corsair-ironclaw-rgb", "Corsair Ironclaw RGB"),
          mouseVersion("corsair-ironclaw-rgb-wireless", "Corsair Ironclaw RGB Wireless"),
          mouseVersion("corsair-m65-rgb-ultra", "Corsair M65 RGB Ultra"),
          mouseVersion("corsair-m65-rgb-ultra-wireless", "Corsair M65 RGB Ultra Wireless"),
        ],
      },
      {
        id: "corsair-compact-mmo",
        name: "Compact / MMO",
        versions: [
          mouseVersion("corsair-katar-elite-wireless", "Corsair Katar Elite Wireless"),
          mouseVersion("corsair-harpoon-rgb-wireless", "Corsair Harpoon RGB Wireless"),
          mouseVersion("corsair-scimitar-rgb-elite", "Corsair Scimitar RGB Elite"),
          mouseVersion("corsair-scimitar-elite-wireless-se", "Corsair Scimitar Elite Wireless SE"),
        ],
      },
    ],
  },
  {
    id: "asus-rog-mice",
    name: "ASUS ROG Gaming Mice",
    brand: "ASUS",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "asus-rog-wireless",
        name: "ROG Wireless",
        versions: [
          mouseVersion("asus-rog-harpe-ace-aim-lab", "ASUS ROG Harpe Ace Aim Lab Edition"),
          mouseVersion("asus-rog-keris-wireless-aimpoint", "ASUS ROG Keris Wireless AimPoint"),
          mouseVersion("asus-rog-keris-ii-ace", "ASUS ROG Keris II Ace"),
          mouseVersion("asus-rog-gladius-iii-wireless", "ASUS ROG Gladius III Wireless"),
          mouseVersion("asus-rog-gladius-iii-wireless-aimpoint", "ASUS ROG Gladius III Wireless AimPoint"),
          mouseVersion("asus-rog-chakram", "ASUS ROG Chakram"),
          mouseVersion("asus-rog-chakram-x-origin", "ASUS ROG Chakram X Origin"),
          mouseVersion("asus-rog-spatha-x", "ASUS ROG Spatha X"),
        ],
      },
      {
        id: "asus-rog-tuf",
        name: "ROG / TUF filaire",
        versions: [
          mouseVersion("asus-rog-strix-impact", "ASUS ROG Strix Impact"),
          mouseVersion("asus-rog-strix-impact-ii", "ASUS ROG Strix Impact II"),
          mouseVersion("asus-rog-strix-impact-iii", "ASUS ROG Strix Impact III"),
          mouseVersion("asus-rog-pugio-ii", "ASUS ROG Pugio II"),
          mouseVersion("asus-tuf-gaming-m4-air", "ASUS TUF Gaming M4 Air"),
          mouseVersion("asus-tuf-gaming-m3", "ASUS TUF Gaming M3"),
        ],
      },
    ],
  },
  {
    id: "hyperx-mice",
    name: "HyperX Gaming Mice",
    brand: "HyperX",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "hyperx-pulsefire",
        name: "Pulsefire",
        versions: [
          mouseVersion("hyperx-pulsefire-haste", "HyperX Pulsefire Haste"),
          mouseVersion("hyperx-pulsefire-haste-wireless", "HyperX Pulsefire Haste Wireless"),
          mouseVersion("hyperx-pulsefire-haste-2", "HyperX Pulsefire Haste 2"),
          mouseVersion("hyperx-pulsefire-haste-2-wireless", "HyperX Pulsefire Haste 2 Wireless"),
          mouseVersion("hyperx-pulsefire-haste-2-mini-wireless", "HyperX Pulsefire Haste 2 Mini Wireless"),
          mouseVersion("hyperx-pulsefire-dart", "HyperX Pulsefire Dart"),
          mouseVersion("hyperx-pulsefire-raid", "HyperX Pulsefire Raid"),
          mouseVersion("hyperx-pulsefire-surge", "HyperX Pulsefire Surge"),
          mouseVersion("hyperx-pulsefire-fps-pro", "HyperX Pulsefire FPS Pro"),
        ],
      },
    ],
  },
  {
    id: "roccat-mice",
    name: "ROCCAT / Turtle Beach Mice",
    brand: "ROCCAT",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "roccat-kone",
        name: "Kone",
        versions: [
          mouseVersion("roccat-kone-original", "ROCCAT Kone"),
          mouseVersion("roccat-kone-aimo", "ROCCAT Kone AIMO"),
          mouseVersion("roccat-kone-pro", "ROCCAT Kone Pro"),
          mouseVersion("roccat-kone-pro-air", "ROCCAT Kone Pro Air"),
          mouseVersion("roccat-kone-xp", "ROCCAT Kone XP"),
          mouseVersion("roccat-kone-xp-air", "ROCCAT Kone XP Air"),
          mouseVersion("roccat-kone-aimo-remastered", "ROCCAT Kone AIMO Remastered"),
          mouseVersion("roccat-kone-emp", "ROCCAT Kone EMP"),
          mouseVersion("roccat-kone-xtd", "ROCCAT Kone XTD"),
          mouseVersion("roccat-kone-pure", "ROCCAT Kone Pure"),
          mouseVersion("roccat-kone-pure-owl-eye", "ROCCAT Kone Pure Owl-Eye"),
          mouseVersion("roccat-kone-pure-ultra", "ROCCAT Kone Pure Ultra"),
          mouseVersion("roccat-kone-pure-se", "ROCCAT Kone Pure SE"),
        ],
      },
      {
        id: "roccat-burst-kain",
        name: "Burst / Kain",
        versions: [
          mouseVersion("roccat-burst-pro", "ROCCAT Burst Pro"),
          mouseVersion("roccat-burst-pro-air", "ROCCAT Burst Pro Air"),
          mouseVersion("roccat-kain-120-aimo", "ROCCAT Kain 120 AIMO"),
          mouseVersion("roccat-kain-200-aimo", "ROCCAT Kain 200 AIMO"),
          mouseVersion("roccat-kain-202-aimo", "ROCCAT Kain 202 AIMO"),
        ],
      },
      {
        id: "roccat-legacy",
        name: "Kova / Tyon / Legacy",
        versions: [
          mouseVersion("roccat-kova", "ROCCAT Kova"),
          mouseVersion("roccat-kova-aimo", "ROCCAT Kova AIMO"),
          mouseVersion("roccat-kiro", "ROCCAT Kiro"),
          mouseVersion("roccat-lua", "ROCCAT Lua"),
          mouseVersion("roccat-savu", "ROCCAT Savu"),
          mouseVersion("roccat-tyon", "ROCCAT Tyon"),
          mouseVersion("roccat-leadr", "ROCCAT Leadr"),
          mouseVersion("roccat-nyth", "ROCCAT Nyth"),
        ],
      },
    ],
  },
  {
    id: "cooler-master-mice",
    name: "Cooler Master Gaming Mice",
    brand: "Cooler Master",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "cooler-master-mm",
        name: "MM Series",
        versions: [
          mouseVersion("cooler-master-mm710", "Cooler Master MM710"),
          mouseVersion("cooler-master-mm711", "Cooler Master MM711"),
          mouseVersion("cooler-master-mm720", "Cooler Master MM720"),
          mouseVersion("cooler-master-mm731", "Cooler Master MM731"),
          mouseVersion("cooler-master-mm712", "Cooler Master MM712"),
        ],
      },
    ],
  },
  {
    id: "glorious-mice",
    name: "Glorious Gaming Mice",
    brand: "Glorious",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "glorious-model-o-d",
        name: "Model O / D",
        versions: [
          mouseVersion("glorious-model-o", "Glorious Model O"),
          mouseVersion("glorious-model-o-wireless", "Glorious Model O Wireless"),
          mouseVersion("glorious-model-o-2", "Glorious Model O 2"),
          mouseVersion("glorious-model-o-2-wireless", "Glorious Model O 2 Wireless"),
          mouseVersion("glorious-model-d", "Glorious Model D"),
          mouseVersion("glorious-model-d-wireless", "Glorious Model D Wireless"),
          mouseVersion("glorious-model-d-2", "Glorious Model D 2"),
          mouseVersion("glorious-model-d-2-wireless", "Glorious Model D 2 Wireless"),
          mouseVersion("glorious-model-i", "Glorious Model I"),
          mouseVersion("glorious-model-i-2-wireless", "Glorious Model I 2 Wireless"),
        ],
      },
    ],
  },
  {
    id: "zowie-mice",
    name: "Zowie Gaming Mice",
    brand: "Zowie",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "zowie-wireless",
        name: "Wireless Esport",
        versions: [
          mouseVersion("zowie-u2", "Zowie U2"),
          mouseVersion("zowie-ec1-cw", "Zowie EC1-CW"),
          mouseVersion("zowie-ec2-cw", "Zowie EC2-CW"),
          mouseVersion("zowie-ec3-cw", "Zowie EC3-CW"),
          mouseVersion("zowie-s1-dw", "Zowie S1-DW"),
          mouseVersion("zowie-s2-dw", "Zowie S2-DW"),
          mouseVersion("zowie-fk1-dw", "Zowie FK1-DW"),
          mouseVersion("zowie-fk2-dw", "Zowie FK2-DW"),
          mouseVersion("zowie-za13-dw", "Zowie ZA13-DW"),
        ],
      },
      {
        id: "zowie-classic",
        name: "Filaire Esport",
        versions: [
          mouseVersion("zowie-ec1-c", "Zowie EC1-C"),
          mouseVersion("zowie-ec2-c", "Zowie EC2-C"),
          mouseVersion("zowie-ec3-c", "Zowie EC3-C"),
          mouseVersion("zowie-s1-c", "Zowie S1-C"),
          mouseVersion("zowie-s2-c", "Zowie S2-C"),
          mouseVersion("zowie-fk1-c", "Zowie FK1-C"),
          mouseVersion("zowie-fk2-c", "Zowie FK2-C"),
          mouseVersion("zowie-za13-c", "Zowie ZA13-C"),
        ],
      },
    ],
  },
  {
    id: "pulsar-mice",
    name: "Pulsar Gaming Mice",
    brand: "Pulsar",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "pulsar-wireless",
        name: "Wireless Esport",
        versions: [
          mouseVersion("pulsar-x2v2", "Pulsar X2V2"),
          mouseVersion("pulsar-x2v2-mini", "Pulsar X2V2 Mini"),
          mouseVersion("pulsar-xlite-v3", "Pulsar Xlite V3"),
          mouseVersion("pulsar-xlite-v3-mini", "Pulsar Xlite V3 Mini"),
          mouseVersion("pulsar-x2h", "Pulsar X2H"),
          mouseVersion("pulsar-x2h-mini", "Pulsar X2H Mini"),
          mouseVersion("pulsar-x2a", "Pulsar X2A"),
          mouseVersion("pulsar-feinmann-f01", "Pulsar Feinmann F01"),
        ],
      },
    ],
  },
  {
    id: "vaxee-mice",
    name: "VAXEE Gaming Mice",
    brand: "VAXEE",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "vaxee-wireless",
        name: "Wireless Esport",
        versions: [
          mouseVersion("vaxee-xe-wireless", "VAXEE XE Wireless"),
          mouseVersion("vaxee-np-01-wireless", "VAXEE NP-01 Wireless"),
          mouseVersion("vaxee-np-01s-wireless", "VAXEE NP-01S Wireless"),
          mouseVersion("vaxee-outset-ax-wireless", "VAXEE OUTSET AX Wireless"),
          mouseVersion("vaxee-zygen-np-01s", "VAXEE ZYGEN NP-01S"),
          mouseVersion("vaxee-e1-wireless", "VAXEE E1 Wireless"),
        ],
      },
    ],
  },
  {
    id: "endgame-gear-mice",
    name: "Endgame Gear Gaming Mice",
    brand: "Endgame Gear",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "endgame-gear-op-xm",
        name: "OP / XM",
        versions: [
          mouseVersion("endgame-gear-op1", "Endgame Gear OP1"),
          mouseVersion("endgame-gear-op1-8k", "Endgame Gear OP1 8K"),
          mouseVersion("endgame-gear-op1w-4k", "Endgame Gear OP1w 4K"),
          mouseVersion("endgame-gear-xm1r", "Endgame Gear XM1r"),
          mouseVersion("endgame-gear-xm2we", "Endgame Gear XM2we"),
          mouseVersion("endgame-gear-xm2w-4k", "Endgame Gear XM2w 4K"),
        ],
      },
    ],
  },
  {
    id: "lamzu-mice",
    name: "Lamzu Gaming Mice",
    brand: "Lamzu",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "lamzu-wireless",
        name: "Wireless Esport",
        versions: [
          mouseVersion("lamzu-atlantis", "Lamzu Atlantis"),
          mouseVersion("lamzu-atlantis-mini", "Lamzu Atlantis Mini"),
          mouseVersion("lamzu-atlantis-mini-4k", "Lamzu Atlantis Mini 4K"),
          mouseVersion("lamzu-maya", "Lamzu Maya"),
          mouseVersion("lamzu-maya-x", "Lamzu Maya X"),
          mouseVersion("lamzu-thorn", "Lamzu Thorn"),
          mouseVersion("lamzu-thorn-4k", "Lamzu Thorn 4K"),
          mouseVersion("lamzu-paro", "Lamzu Paro"),
        ],
      },
    ],
  },
  {
    id: "finalmouse-mice",
    name: "Finalmouse Gaming Mice",
    brand: "Finalmouse",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "finalmouse-ultralight",
        name: "Ultralight / Starlight",
        versions: [
          mouseVersion("finalmouse-ultralight-2-cape-town", "Finalmouse Ultralight 2 Cape Town"),
          mouseVersion("finalmouse-air58-ninja", "Finalmouse Air58 Ninja"),
          mouseVersion("finalmouse-starlight-12-small", "Finalmouse Starlight-12 Small"),
          mouseVersion("finalmouse-starlight-12-medium", "Finalmouse Starlight-12 Medium"),
          mouseVersion("finalmouse-ultralightx-lion", "Finalmouse UltralightX Lion"),
          mouseVersion("finalmouse-ultralightx-tiger", "Finalmouse UltralightX Tiger"),
        ],
      },
    ],
  },
  {
    id: "xtrfy-mice",
    name: "Xtrfy / CHERRY XTRFY Mice",
    brand: "Xtrfy",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "xtrfy-m-series",
        name: "M Series",
        versions: [
          mouseVersion("xtrfy-m4-rgb", "Xtrfy M4 RGB"),
          mouseVersion("xtrfy-m4-wireless", "Xtrfy M4 Wireless"),
          mouseVersion("xtrfy-m42-rgb", "Xtrfy M42 RGB"),
          mouseVersion("xtrfy-m42-wireless", "Xtrfy M42 Wireless"),
          mouseVersion("xtrfy-m8-wireless", "Xtrfy M8 Wireless"),
          mouseVersion("xtrfy-mz1-zy-rail", "Xtrfy MZ1 Zy's Rail"),
          mouseVersion("xtrfy-mz1-wireless", "Xtrfy MZ1 Wireless"),
        ],
      },
    ],
  },
  {
    id: "fnatic-mice",
    name: "Fnatic Gaming Mice",
    brand: "Fnatic",
    type: "mouse",
    category: "Souris gaming",
    variants: [
      {
        id: "fnatic-bolt-flick",
        name: "Bolt / Flick",
        versions: [
          mouseVersion("fnatic-bolt", "Fnatic Bolt"),
          mouseVersion("fnatic-bolt-2", "Fnatic Bolt 2"),
          mouseVersion("fnatic-flick-2", "Fnatic Flick 2"),
        ],
      },
    ],
  },
  {
    id: "apple-mice",
    name: "Apple Pointing Devices",
    brand: "Apple",
    type: "mouse",
    category: "Souris premium",
    variants: [
      {
        id: "apple-magic",
        name: "Magic",
        versions: [
          mouseVersion("apple-magic-mouse", "Apple Magic Mouse"),
          mouseVersion("apple-magic-trackpad", "Apple Magic Trackpad"),
        ],
      },
    ],
  },
];
